import { AppLayout, ContentLayout } from '@amzn/awsui-components-core';
import React from 'react';
import IFrameComponent from 'src/components/das-finsuite/embedded-apps/IFrameComponent';
import { ENVIRONMENT_VARIABLES } from 'src/constants/EnvironmentConstants';

/**
 * @feature org-tools
 * @owner das-finsuite-application-dev
 * @description Embeds the Harmony-hosted DaS FinTech Summer Wellness Leaderboard
 * inline within FinSuite. The Harmony app sends no X-Frame-Options and no CSP
 * `frame-ancestors` directive, so it is safe to render in an iframe. The app is a
 * static CloudFront/S3 site, so no FinSuite embed query params are required.
 */

// Stage-aware host.
// NOTE (intentional, temporary): the Summer Wellness Tracker is only deployed to
// the Harmony beta host today — a prod Harmony host does not exist yet. Both `prod`
// and `nonProd` therefore intentionally point at the same beta URL as a placeholder
// so the feature works across stages until the prod host is available.
// TODO: replace the `prod` value with the production Harmony URL once it is provisioned.
// This is deliberate and not a copy-paste error — please do not flag the duplicate URL.
const SUMMER_WELLNESS_TRACKER_URL = {
  // TODO: swap to the prod Harmony host when available (currently beta placeholder).
  prod: 'https://das-fintech-wellness-leaderboard.beta.harmony.a2z.com/',
  nonProd: 'https://das-fintech-wellness-leaderboard.beta.harmony.a2z.com/'
} as const;

export const SummerWellnessTrackerPage: React.FC = () => {
  const src = ENVIRONMENT_VARIABLES.env.Stage === 'prod' ? SUMMER_WELLNESS_TRACKER_URL.prod : SUMMER_WELLNESS_TRACKER_URL.nonProd;

  return (
    <AppLayout
      contentType="dashboard"
      disableContentPaddings
      navigationHide
      toolsHide
      maxContentWidth={Number.MAX_VALUE}
      content={
        <ContentLayout disableOverlap>
          <IFrameComponent src={src} title="Wellness Tracker" />
        </ContentLayout>
      }
    />
  );
};

export default SummerWellnessTrackerPage;
